import { iconByName } from "@/lib/icons";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { INDUSTRY_PAGES } from "@/data/industries";
import { Reveal, SectionHeader } from "@/components/Reveal";

const Industries = () => (
    <section id="industries" data-testid="industries-section" className="scroll-mt-24 relative overflow-hidden t-bg-alt py-14 md:py-24">
        <img loading="lazy" decoding="async" src="/backgrounds/07-industries.webp" alt="" aria-hidden="true" className="plate pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.12]" />
        <div className="container-x relative">
            <Reveal>
                <SectionHeader
                    eyebrow="Industries"
                    title="Deep context in the sectors we serve"
                    intro="Technology only creates advantage when it speaks the language of the industry. We bring domain context to every engagement."
                />
            </Reveal>

            <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                {INDUSTRY_PAGES.map((ind, i) => {
                    const Icon = iconByName(ind.icon);
                    return (
                        <Reveal key={ind.slug} delay={(i % 4) * 0.07}>
                            <Link
                                to={`/industries/${ind.slug}`}
                                data-testid={`industry-tile-${ind.slug}`}
                                className="group relative flex h-full min-h-[220px] flex-col justify-between overflow-hidden rounded-2xl border t-border t-surface p-7 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-electric/40 hover:shadow-[0_24px_60px_-24px_rgba(30,144,255,0.35)]"
                            >
                                <img
                                    src={ind.visual}
                                    alt=""
                                    loading="lazy"
                                    aria-hidden="true"
                                    className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-0 transition-[opacity,transform] duration-700 group-hover:scale-105 group-hover:opacity-25"
                                />
                                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-navy-900/90 via-navy-900/40 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                                <div
                                    className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-electric/0 blur-2xl transition-[background-color] duration-500 group-hover:bg-electric/20"
                                    aria-hidden="true"
                                />
                                <div className="relative flex items-start justify-between">
                                    <Icon
                                        size={30}
                                        strokeWidth={1.5}
                                        className="t-soft transition-colors duration-300 group-hover:text-electric"
                                    />
                                    <ArrowUpRight
                                        size={18}
                                        className="translate-y-1 text-electric opacity-0 transition-[opacity,transform] duration-300 group-hover:translate-y-0 group-hover:opacity-100"
                                    />
                                </div>
                                <div className="relative mt-10">
                                    <h3 className="font-display text-lg font-semibold leading-snug t-heading">{ind.name}</h3>
                                    <p className="mt-2 max-h-0 overflow-hidden text-[13px] leading-relaxed t-soft opacity-0 transition-[max-height,opacity] duration-500 group-hover:max-h-24 group-hover:opacity-100">
                                        {ind.tileDesc}
                                    </p>
                                </div>
                            </Link>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);

export default Industries;
